import React from 'react';

import { Tag } from 'primereact/tag';

import { Employee } from '../../types/interfaces';

import { getPriorityStyle } from './helpers';

interface ExecutorsBodyTemplateProps {
  employees: Employee[];
}

export const ExecutorsBodyTemplate: React.FC<ExecutorsBodyTemplateProps> = ({
  employees
}) => {
  if (!employees || !Array.isArray(employees)) {
    console.error('Invalid employees data:', employees);
    return null;
  }

  return employees.map((executor) => (
    <Tag
      style={{ background: 'rgb(225, 234, 245)', color: '#495057' }}
      className="mr-1"
      key={executor.id}
    >
      {executor.label ? executor.label : executor.fullName}
    </Tag>
  ));
};

export const PriorityBodyTemplate = (rowData: { priority: string }) => {
  const priority = rowData.priority;

  return (
    <div style={getPriorityStyle(priority)}>
      {priority === 'Высокий' ? (
        <i
          className="pi pi-exclamation-triangle"
          style={{ marginRight: '5px' }}
        ></i>
      ) : (
        <div style={{ width: '19px', height: '1px' }}></div>
      )}
      {priority}
    </div>
  );
};
